import React from 'react';

import PageBanner from '../../../components/pageBanner/PageBanner';
import PageContainer from '../../../components/pageContainer/PageContainer';

import CertificatesInfoTable from './CertificatesInfoTable';

function CertificateReceiverHome() {
  return (
    <PageContainer>
      <PageBanner/>
      <CertificatesInfoTable/>
    </PageContainer>
  );
}

export default CertificateReceiverHome;
